
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import NotificationPopup from '@/components/Common/NotificationPopup.vue';
import { EnvironmentBaseURL, Root } from '@/main';
import { ApplicationViewModel } from '@/entities/Application/ApplicationViewModel';
import { EventSideMenu } from '@/entities/Application/EventSideMenu';
import { ApplicationSideMenu } from '@/entities/Application/ApplicationSideMenu';
import { NavBarImages } from '@/entities/Application/NavBarImages';
import { AppNavBarImages } from '@/entities/Application/AppNavBarImages';
import { useRoute } from 'vue-router';

@Component({
  components: {
    NotificationPopup,
  },
})
class TopNavBar extends Vue {
  @Prop() viewModel!: ApplicationViewModel;
  @Prop() menuItems!: EventSideMenu | ApplicationSideMenu;
  @Prop() appAndBackgroundColor!: any;
  @Prop() appColor!: { color: string };
  @Prop() appFontColor!: { color: string };
  @Prop() iconImages!: NavBarImages | AppNavBarImages;
  @Prop() activeComponent!: string;
  private bellIcon = require('@/assets//Images/notification-base.svg');
  private loadingImage: string = require('@/assets/Images/loading-dots-white.gif');
  public AppColor: any = { color: '' };
  public AppFontColor = {color: ''};
  // private activeComponent = 'eventsetting';
  public isLeftMenuBarShow =  true;
  private notificationPopupVisible = false;
  private toggledNav = false;
  private showNotificationLoading = false;
  private showNotificationIcon = true;
  private mouseOverOnNotification = false;
  private router = useRoute();
  private images: NavBarImages = new NavBarImages();
  private externalLeftMenuimages: AppNavBarImages = new AppNavBarImages();
  private isMobile = false;
  private latestNewsIcon = require('@/assets/Images/latest-news.svg');
  private manageAapplicationsIcon = require('@/assets/Images/manage-applications-icon.svg');
  private changePasswordIcon = require('@/assets/Images/change-password.svg');
  private licenceDetailsIcon = require('@/assets/Images/licence-details-icon.svg');
  private inviteCoordinatorIcon = require('@/assets/Images/invite-coordinator.svg');
  private logoutIcon = require('@/assets/Images/log-out.svg');
  private helpIcon = require('@/assets/Images/help.svg');
  private meetappSignoutURL = '';
  public AppColorAndBackgroundColor: any = {
    color: '',
    backgroundColor: '',
    visibility: 'hidden',
  };

  // Use Getters
  // These update automatically when viewModel changes.
  get isLoggedInUserSuperAdmin() {
    return this.viewModel.LoggedInUserInformation.AdminTypeForUpperRightCorner === 'Super Admin';
  }

  get isLoggedInUserApplicationAdmin() {
    return this.viewModel.LoggedInUserInformation.AdminTypeForUpperRightCorner === 'Application Admin';
  }

  get isLoggedInUserEventAdmin() {
    return this.viewModel.LoggedInUserInformation.AdminTypeForUpperRightCorner === 'Event Admin';
  }

  get isLoggedInUserAADAdmin() {
    return !!this.viewModel.LoggedInUserInformation.IsActiveDirectoryAdminUser;
  }

  get isLoggedinUserOAuthAdmin() {
    return !!this.viewModel.LoggedInUserInformation.IsOAuthAdminUser;
  }

  get isOrgSettingsPage() {
    return this.router.name === 'orgsettings';
  }

  private mounted(){
    if(window.innerWidth <= 991) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.GetSignoutUrl();
  }

  private CheckAndHideNotificationPopup() {
    if (this.notificationPopupVisible === true) {
      this.notificationPopupVisible = false;
    }
  }

  private GetImageSrc(id: number, isActive: boolean) {
    return isActive ? this.iconImages.NavBarImage[id].ActiveImageSrc : this.iconImages.NavBarImage[id].ImageSrc;
  }

  // Helper to ensure external URLs are formatted correctly
  private GetFullExternalUrl(url: string) {
    if (!url) {
      return 'javascript:void(0)';
    }
    // Prepend Environment URL if it's a relative path
    const baseUrl = (this as any).$EnvironmentBaseURL;
    return url.startsWith('http') ? url : baseUrl + url;
  }

  private GetCurrentModuleName() {
    if(this.isOrgSettingsPage) {
      return this.$t('OrgSettings.Title').toUpperCase();
    }
    if(this.viewModel.ActiveEvent.Id > 0) {
      switch(this.activeComponent) {
      case 'eventsetting':
        return this.$t('Settings').toUpperCase();
      case 'watchlive':
        return this.activeComponent.toUpperCase();
      case 'eventpage':
        return this.activeComponent.toUpperCase();
      case 'program':
        return this.activeComponent.toUpperCase();
      case 'customCategory':
        return this.$t('Information').toUpperCase();
      case 'notification':
        return this.$t('Dialogue').toUpperCase();
      case 'participants':
        return this.$t('Participants').toUpperCase();
      case 'invite':
        return this.$t('Registrationmanager').toUpperCase();
      }
    } else {
      return this.$t('CreateNewEvent').toUpperCase();
    }
  }

  private ShowBellIcon() {
    if (this.router.name === 'eventsetting' || this.router.name === 'watchlive' || this.isOrgSettingsPage) {
      this.showNotificationIcon  = false;
      return false;
    } else {
      this.showNotificationIcon = true;
      return true;
    }
  }
  private HideAppLogo() {
    return this.isMobile && !this.toggledNav ;
  }
  private MouseOverNotification(mouseOver: boolean) {
    this.mouseOverOnNotification = mouseOver;
    this.ShowNotificationPopup();
  }
  private ShowNotificationPopup() {
    this.notificationPopupVisible = true;
    Root.emit(
      'reload-all-notifications',
    );
    setTimeout(() => {
      this.HideNotificationPopup();
    }, 3000);
  }

  private HideNotificationPopup() {
    if (!this.mouseOverOnNotification) {
      this.notificationPopupVisible = false;
    }
  }
  private ClickedInsidePopup( event: any) {
    event.stopPropagation();
  }

  private OpenHelpLink() {
    window.open('https://support.ventla.io/kb/', '_blank', 'noreferrer');
  }
  private GetLoggedInUserNameInitials() {
    return this.viewModel.LoggedInUserInformation.Firstname.charAt(0) + this.viewModel.LoggedInUserInformation.Lastname.charAt(0);
  }

  private OpenNewsFlash() {
    this.$emit('show-latest-news-dialog', true);
  }

  // Show Popup on click of license details link
  private OpenLicenseDescription() {
    this.$emit('show-license-details', true);
  }

  private GetSignoutUrl() {
    if (this.viewModel.ApplicationInformation.EnableCustomOAuthAuthorization) {

      this.meetappSignoutURL = EnvironmentBaseURL + '/Admin/Auth/AuthSignOut?Id=' + this.viewModel.ApplicationInformation.Id;
    } else {
      this.meetappSignoutURL = EnvironmentBaseURL + '/Admin/Auth/SignOut';
    }
  }

}
export default toNative(TopNavBar);
